export default {"src":"/_next/static/media/subscription.ad2c3f8b.svg","height":494,"width":761,"blurWidth":0,"blurHeight":0};